// extracted by mini-css-extract-plugin
export default {"healthBoss":"D6roit","hide":"sggpU_","heart":"P8CfSw","left":"bTY4hZ","right":"Hr8DIe","shield":"r1V4sv","empty":"pVURzx","kalts":"yrqbL5","health":"pjc4rm"};